import i18n from './i18n';

export const FlashDefinition = {
  setupSuccess: {
    context: [{ detail: i18n.flashSetupSuccess }],
    status: 'success',
  },
  setupError: {
    context: [{ detail: i18n.flashSetupError }],
    status: 'error',
  },
  disableSuccess: {
    context: [{ detail: i18n.flashDisableSuccess }],
    status: 'success',
  },
  disableError: {
    context: [{ detail: i18n.flashDisableError }],
    status: 'error',
  },
  invalidCode: {
    context: [{ detail: i18n.flashInvalidCode }],
    status: 'error',
  },
  accountLocked: {
    context: [{ detail: i18n.flashAccountLocked }],
    status: 'error',
  },
  backupCodesRegenerated: {
    context: [{ detail: i18n.flashBackupCodesRegenerated }],
    status: 'success',
  },
  passwordRequired: {
    context: [{ detail: i18n.flashPasswordRequired }],
    status: 'error',
  },
  invalidCodeFormat: {
    context: [{ detail: i18n.flashInvalidCodeFormat }],
    status: 'error',
  },
  statusFetchError: {
    context: [{ detail: i18n.flashStatusFetchError }],
    status: 'error',
  },
  incorrectPassword: {
    context: [{ detail: i18n.flashIncorrectPassword }],
    status: 'error',
  },
  disablePasswordRequired: {
    context: [{ detail: i18n.flashDisablePasswordRequired }],
    status: 'error',
  },
  disableEnforcementActive: {
    context: [{ detail: i18n.flashDisableEnforcementActive }],
    status: 'error',
  },
  enforcementEnabled: {
    context: [{ detail: i18n.flashEnforcementEnabled }],
    status: 'success',
  },
  enforcementDisabled: {
    context: [{ detail: i18n.flashEnforcementDisabled }],
    status: 'success',
  },
  enforcementUpdateError: {
    context: [{ detail: i18n.flashEnforcementUpdateError }],
    status: 'error',
  },
  ownerMfaRequired: {
    context: [{ detail: i18n.flashOwnerMfaRequired }],
    status: 'error',
  },
  removeUserMFASuccess: {
    context: [{ detail: i18n.flashRemoveUserMFASuccess }],
    status: 'success',
  },
  removeUserMFAError: {
    context: [{ detail: i18n.flashRemoveUserMFAError }],
    status: 'error',
  },
  codeRequired: {
    context: [{ detail: i18n.codeRequired }],
    status: 'error',
  },
  codeInvalid: {
    context: [{ detail: i18n.codeInvalid }],
    status: 'error',
  },
  backupCodesCopied: {
    context: [{ detail: i18n.backupCodesCopied }],
    status: 'success',
  },
  backupCodesCopyFailed: {
    context: [{ detail: i18n.backupCodesCopyFailed }],
    status: 'error',
  },
  backupCodesDownloaded: {
    context: [{ detail: i18n.backupCodesDownloaded }],
    status: 'success',
  },
  secretKeyCopied: {
    context: [{ detail: i18n.secretKeyCopied }],
    status: 'success',
  },
  trustedDevicesLoadError: {
    context: [{ detail: i18n.trustedDevicesLoadError }],
    status: 'error',
  },
  trustedDevicesRevoked: {
    context: [{ detail: i18n.trustedDevicesRevoked }],
    status: 'success',
  },
  trustedDevicesRevokeError: {
    context: [{ detail: i18n.trustedDevicesRevokeError }],
    status: 'error',
  },
  trustedDevicesAllRevoked: {
    context: [{ detail: i18n.trustedDevicesAllRevoked }],
    status: 'success',
  },
};
